import React, { useEffect, useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReactTable from "react-table";
import {Redirect} from "react-router-dom";
import Typography from '@mui/material/Typography';
import {GPAP_Button_light} from "../../../../gpap-lib/Button_Collection";
import PopupMessage from "../components/PopupMessage";
import Loading from "../../components/LoadingTable";
import auth from '../../../service/Auth';
import { downloadCSV, CsvButton } from '../../../service/CsvButton';
import { asperaexperimentsinformation } from '../../../service/apis';

const config = window.config;

const headerMainTable = [
    {label: "Experiment", key: "experiment", tooltip: "Experiment ID."},
    {label: "Submitter", key: "submitter", tooltip: "Experiment submitter mail."},
    {label: "Experiment Status", key: "experiment_status",tooltip: "Experiment status at Red Iris."},
    {label: "Files Uploaded", key: "uploaded", tooltip: "Files at Red Iris."},
    {label: "Files Missing", key: "missing", tooltip: "Files not found at Red Iris Server."}
];

const headerSummaryTable = [
     { label: "Experiments Completely Uploaded" , key: "completed",tooltip: "Experiments with all files at Red Iris."},
     { label: "Experiments Partially Uploaded" , key: "not_completed",tooltip: "Experiments partially uploaded."},
     { label: "Experiments Not Uploaded" , key: "not_uploaded",tooltip: "Experiments with no files uploaded."}
];

const AsperaExperiments = (props) =>{

    const [data, setData] = useState({});
    const [title, setTitle] = useState("");
    const [errors, setErrors] = useState("");
    const [goBack, setGoBack] = useState(false);
    const [loading, setLoading] = useState(true);
    const [columnsMainTable, setColumnsMainTable] = useState([]);
    const [rowsMainTable, setRowsMainTable] = useState([]);
    const [columnsSummaryTable, setColumnsSummaryTable] = useState([]);
    const [rowsSummaryTable, setRowsSummaryTable]  = useState([]);
    

    const fetchData = async (body) => {        
        await asperaexperimentsinformation(auth.getToken(),config.api_endpoint,JSON.stringify(body))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            setData(data);
            setTitle("Experiments found at " + props.location.share + " Aspera Shares folder for groups " + props.location.apiInfo[props.location.share].group.join(" ") )
            setLoading(false);
        });
    } 

    useEffect(() => {
        // 1.Logging Check 
        if (auth.tokenExpired()) {
            setErrors("Logging session timeout. Please log again");
        }
        else if (!auth.isUserAdmin()) {
            setErrors("User does not have admin permissions.");
        }
        else {
            // 1.1 Initialise body post
            let dataPost = {"aspera_files": props.location.apiInfo[props.location.share].files,
                                  "aspera_experiments": props.location.apiInfo[props.location.share].experiments,
                                  "aspera_group_experiments": props.location.apiInfo[props.location.share].group
            };
            // 2.2 Fetch Data
            fetchData(dataPost)
        }   
    }, [])
    
    const updateMainTableColumns = () => {
        // Main Table Header configuration
        let columns = [];
        for (let header of headerMainTable) {
              let column = {};
              column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
              column["accessor"] = header.key;
              column["minWidth"] = 220;
              columns.push(column);
        }
        setColumnsMainTable(columns);
    }
      
    const updateMainTableRows = () => {
        // 0. Main Table Rows setting
        const rows = [];
        // 1. Recover data
        if (Object.entries(data).length !== 0) {
            // 2. Completed
            for (let experimentObject of data["completed"]) {
              let row = {};
              row["experiment"] = experimentObject["experiment"];
              row["submitter"] = experimentObject["submitter"];
              row["experiment_status"] = "COMPLETED";
              row["missing"] = experimentObject["missing"];
              row["uploaded"] = experimentObject["uploaded"];
              rows.push(row);
            }
            // 3. Not Completed
            for (let experimentObject of data["not_completed"]) {
              let row = {};
              row["experiment"] = experimentObject["experiment"];
              row["submitter"] = experimentObject["submitter"];
              row["experiment_status"] = "NOT COMPLETED";
              row["missing"] = experimentObject["missing"];
              row["uploaded"] = experimentObject["uploaded"];
              rows.push(row);
            }
            // 4. Not Uploaded
            for (let experimentObject of data["not_uploaded"]) {
              let row = {};
              row["experiment"] = experimentObject["experiment"];
              row["submitter"] = experimentObject["submitter"];
              row["experiment_status"] = "NOT UPLOADED";
              row["missing"] = experimentObject["missing"];
              row["uploaded"] = experimentObject["uploaded"];
              rows.push(row);
            }
        }
        setRowsMainTable(rows);
    }
    
    const updateSummaryTableColumns = () => {
        // Main Table Header configuration
        let columns = [];
        for (let header of headerSummaryTable) {
              let column = {};
              column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
              column["accessor"] = header.key;
              column["minWidth"] = 220;
              columns.push(column);
        }
        setColumnsSummaryTable(columns);
    }
    
    const updateSummaryTableRows = () => {
        // Build data table
        let rows = [];
        // Build Rows
        if (Object.entries(data).length !== 0) {
            let row = {};
            row["completed"] = ("completed" in  data) ? data["completed"].length : 0;
            row["not_completed"] = ("not_completed" in  data) ? data["not_completed"].length : 0;
            row["not_uploaded"] = ("not_uploaded" in  data) ? data["not_uploaded"].length : 0;
            rows.push(row);
        }
        setRowsSummaryTable(rows);
    }
    
    // To be triggered when data is updated
    useEffect(() => {
        // 0. Setup Headers
        updateMainTableColumns();
        // 1. Setup Rows
        updateMainTableRows();
        // 2. Setup Summary headers
        updateSummaryTableColumns();
        // 3. Setup Rows Summary Table Columns
        updateSummaryTableRows();
    }, [data])
             
    const goBackButton = (event) => {
        // Back Button Redirection method
        setGoBack(true);
    }
    
    const getCsvData = (events) => {
        // Trigger CSV Download
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(rowsMainTable,headerMainTable,`${today}_aspera_experiments.csv`);
    }
 
    // If errors then popup a message
    if (errors !== "") {
        return <PopupMessage title={"Logging error!"} message={errors} href={"#/admin"} />;
    }
    else if (goBack) {
        return <Redirect to={{pathname:'/admin/aspera',data:props.location.apiInfo}} />;
    }
    else {
        return (
            <div className={"mainContent"}>
                <Typography variant={"h5"} align={"center"}> {title} </Typography>
                <GPAP_Button_light onClick={goBackButton}  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_light>
                <CsvButton getCsvData={getCsvData} />
                { /* Summary Table */ }
                <ReactTable
                    data={rowsSummaryTable}
                    columns={columnsSummaryTable}
                    defaultPageSize = {1}
                    className="-striped -highlight"
                    style={{ height: 60 }}
                    showPagination={false}
                    loading={loading}
                    LoadingComponent={Loading}
                />
                { /* Main Table */ }
                <ReactTable
                    data={rowsMainTable}
                    filterable
                    columns={columnsMainTable}
                    defaultPageSize = {100}
                    pageSizeOptions = {[100, 200, 300]}
                    className="-striped -highlight"
                    style={{ height: 700 }}
                    loading={loading}
                    LoadingComponent={Loading}
                />
              </div>
        );
    }
} 
 
export default AsperaExperiments;